import { Link } from "react-router-dom";
import RatingBadge from "@/components/base/RatingBadge";
import type { Film } from "@/mocks/films";

type FilmCardProps = {
  film: Film;
  compact?: boolean;
};

const FilmCard = ({ film, compact = false }: FilmCardProps) => (
  <Link
    to={`/detail/${film.id}`}
    className="group block cursor-pointer"
    aria-label={`查看《${film.title}》详情`}
  >
    <div className="relative w-full overflow-hidden rounded-lg bg-background-200 aspect-[2/3]">
      <img
        src={film.poster}
        alt={`${film.title} ${film.year} ${film.genres.join("·")} 电影海报`}
        title={`${film.title} ${film.genres.join("·")} 影视详情与剧情介绍`}
        className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-[1.04]"
      />
      <div className="absolute inset-x-0 bottom-0 h-1/2 bg-gradient-to-t from-foreground-950/85 to-transparent opacity-0 transition-opacity duration-300 group-hover:opacity-100" />
      <div className="absolute left-2 top-2">
        <RatingBadge rating={film.rating} />
      </div>
      <p className="absolute inset-x-3 bottom-3 line-clamp-2 text-xs leading-relaxed text-background-50 opacity-0 transition-opacity duration-300 group-hover:opacity-100">
        {film.tagline}
      </p>
    </div>
    <div className={compact ? "pt-2" : "pt-3"}>
      <h3 className="truncate font-heading text-[15px] font-semibold text-foreground-950 transition-colors group-hover:text-primary-600">
        {film.title}
      </h3>
      <p className="mt-1 flex items-center gap-1.5 text-xs text-foreground-500">
        <span>{film.year}</span>
        <span className="text-background-400">/</span>
        <span className="truncate">{film.genres.slice(0, 2).join(" · ")}</span>
      </p>
    </div>
  </Link>
);

export default FilmCard;